import { render, staticRenderFns } from "./ShiftsGrid.vue?vue&type=template&id=f3260eca&scoped=true"
import script from "./ShiftsGrid.vue?vue&type=script&lang=js"
export * from "./ShiftsGrid.vue?vue&type=script&lang=js"
import style0 from "./ShiftsGrid.vue?vue&type=style&index=0&id=f3260eca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3260eca",
  null
  
)

export default component.exports